import { IContentPlaylist } from './IContentPlaylist';
import { getSubPlaylistUrlFromRelative, getSubPlaylistUrl } from './PlaylistUtils';

const MASTER_V2_CONTENT_LINES_REGEX = /NAME="content_\d+\.\d+(_\d+\.\d+)?",DEFAULT=NO,AUTOSELECT=NO,URI=".+\.m3u8.*"$/gm;
const MASTER_V2_CONTENT_NAME_PARSE_REGEX = /NAME="content_(\d+\.\d+)_?(\d+\.\d+)?/;
const MASTER_V2_SPEAKER_PLAYLIST_FILE_NAME_REGEX = /NAME="speaker",DEFAULT=NO,AUTOSELECT=NO,URI="(.+\.m3u8.*)"/;
const MASTER_V2_CONTENT_PLAYLIST_FILE_NAME_REGEX = /URI="(.+\.m3u8.*)"$/;

export class MasterPlaylistParserHelperV2 {
	public static getSpeakerPlaylistUrl(masterPlaylistUrl: string, masterPlaylistString: string): string {
		const [, speakerPlaylistFilename] = masterPlaylistString.match(MASTER_V2_SPEAKER_PLAYLIST_FILE_NAME_REGEX);

		return getSubPlaylistUrlFromRelative(masterPlaylistUrl, speakerPlaylistFilename);
	}

	public static getContentPlaylists(masterPlaylistUrl: string, masterPlaylistString: string): Map<string, IContentPlaylist> {
		const contentPlaylists = new Map<string, IContentPlaylist>();
		const contentPlaylistMatches = masterPlaylistString.match(MASTER_V2_CONTENT_LINES_REGEX) || [];

		contentPlaylistMatches.forEach((contentPlaylistLine: string) => {
			const [, startStr, endStr] = contentPlaylistLine.match(MASTER_V2_CONTENT_NAME_PARSE_REGEX); //array destructuring with first value ignored

			contentPlaylists.set(startStr, {
				start: parseFloat(startStr),
				end: endStr ? parseFloat(endStr) : null, //may not be present in live scenario
				url: this.getContentPlaylistUrl(masterPlaylistUrl, contentPlaylistLine)
			});
		});

		return contentPlaylists;
	}

	public static getContentPlaylistUrl(masterPlaylistUrl: string, contentPlaylistLine: string): string {
		//For v2 of playlist, extract the file name from the line (rather than build based on the name)
		const [, contentPlaylistFileName] = contentPlaylistLine.match(MASTER_V2_CONTENT_PLAYLIST_FILE_NAME_REGEX);

		return getSubPlaylistUrl(masterPlaylistUrl, contentPlaylistFileName);
	}
}
